import multireducer from "./multireducer";
import wrapDispatch from "./wrapDispatch";

export { multireducer, wrapDispatch };

export default {
  multireducer,
  wrapDispatch
};